/**
 * @file main.tab.tsx
 * @description Основная таба формы баг-репорта. 
 * Содержит поля для детального описания ошибки: описание с поддержкой вложений, сценарий воспроизведения,
 * ожидаемый и фактический результаты. Поддерживает drag-and-drop загрузку файлов через DragNDropZone.
 * Использует rich text редакторы для форматированного ввода текста и AttachmentsRichText для работы с файлами.
 * @author AI Assistant
 * @created 2025-09-04
 * @updated 2025-09-04
 * @dependencies [react, @src/types, @components/form-controls/collapsed/rich-text, @components/form-controls/drag-n-drop-zone, @components/form-controls/collapsed/attachments-rich-text]
 * @related-files [@forms/bug/bug.form.tsx, @components/form-controls/collapsed/rich-text/rich-text.component.tsx, @components/form-controls/drag-n-drop-zone/drag-n-drop-zone.component.tsx]
 */

import { tabProps } from '@src/types';
import { RichText } from '@components/form-controls/collapsed/rich-text';
import { DragNDropZone } from '@components/form-controls/drag-n-drop-zone';
import { AttachmentsRichText } from '@src/components/form-controls/collapsed/attachments-rich-text';

export const Main = ({ control }: tabProps) => {
    return (
        <DragNDropZone className="flex flex-col h-full gap-[1.0585vmin]" name="attachments" control={control}>
            <AttachmentsRichText
                label="Описание"
                name="description"
                control={control}
                placeholder="Добавьте описание ошибки"
            />

            <RichText label="Сценарий" name="playbackScenario" control={control} />

            <RichText label="Ожидаемый результат" name="expectedResult" control={control} />

            <RichText label="Фактический результат" name="actualResult" control={control} />
        </DragNDropZone>
    );
};
